import { addDays, addMonths } from "../../../../../../react-core/utils/date";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { Frequency } from "../../../../../../Wrap/Constants/Enums/Domain/Frequency";
import { ContributionAndWithdrawalBase } from "../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Shared/ContributionAndWithdrawalBase";

export class PaymentsHelper {
    static hasRegularPayments(model: ContributionAndWithdrawalBase): boolean {
        const productObject = model;

        if (productObject == null) {return false;}

        const client = productObject.ClientRegularPayment != null && productObject.ClientRegularPayment.Money != null;
        const thirdParty =
            productObject.ThirdPartyRegularPayment != null && productObject.ThirdPartyRegularPayment.Money != null;

        return client || thirdParty;
    }

    static hasSinglePayments(model: ContributionAndWithdrawalBase): boolean {
        const productObject = model;

        if (productObject == null) {return false;}

        const client = productObject.ClientSinglePayment != null && productObject.ClientSinglePayment.Money != null;
        const thirdParty =
            productObject.ThirdPartySinglePayment != null && productObject.ThirdPartySinglePayment.Money != null;

        return client || thirdParty;
    }

    static singlePaymentsTotal(model: ContributionAndWithdrawalBase): number {
        let total = 0;
        if (model.ClientSinglePayment != null && model.ClientSinglePayment.Money != null) {
            total += model.ClientSinglePayment.Money.Amount;
        }
        if (model.ThirdPartySinglePayment != null && model.ThirdPartySinglePayment.Money != null) {
            total += model.ThirdPartySinglePayment.Money.Amount;
        }

        return total;
    }

    static regularPaymentsTotalForCharges(model: ContributionAndWithdrawalBase): number {
        let total = 0;
        if (model.ClientRegularPayment != null && model.ClientRegularPayment.Money != null) {
            total += model.ClientRegularPayment.Money.Amount;
        }
        if (model.ThirdPartyRegularPayment != null && model.ThirdPartyRegularPayment.Money != null) {
            total += model.ThirdPartyRegularPayment.Money.Amount;
        }

        return total;
    }

    static regularPaymentsCurrentTaxYearTotal(model: ContributionAndWithdrawalBase, taxYearEnd: Date): number {
        let total = 0;

        if (
            model.ClientRegularPayment != null &&
            model.ClientRegularPayment.Money != null &&
            model.ClientRegularPayment.Frequency != null &&
            model.ClientRegularPayment.FirstCollectionDate != null
        ) {
            let endDate = new Date();
            if (
                model.ClientRegularPayment.ContinueUntil == null ||
                taxYearEnd < JsonDateParser.toDate(model.ClientRegularPayment.ContinueUntil)
            ) {
                endDate = taxYearEnd;
            } else {
                endDate = JsonDateParser.toDate(model.ClientRegularPayment.ContinueUntil);
            }

            total +=
                model.ClientRegularPayment.Money.Amount *
                this.getRegularPaymentsCount(
                    JsonDateParser.toDate(
                        model.ClientRegularPayment.NextPaymentDate ?? model.ClientRegularPayment.FirstCollectionDate
                    ),
                    model.ClientRegularPayment.Frequency,
                    endDate
                );
        }
        if (
            model.ThirdPartyRegularPayment != null &&
            model.ThirdPartyRegularPayment.Money != null &&
            model.ThirdPartyRegularPayment.Frequency != null &&
            model.ThirdPartyRegularPayment.FirstCollectionDate != null
        ) {
            let endDate = new Date();
            if (
                model.ThirdPartyRegularPayment.ContinueUntil == null ||
                taxYearEnd < JsonDateParser.toDate(model.ThirdPartyRegularPayment.ContinueUntil)
            ) {
                endDate = taxYearEnd;
            } else {
                endDate = JsonDateParser.toDate(model.ThirdPartyRegularPayment.ContinueUntil);
            }

            total +=
                model.ThirdPartyRegularPayment.Money.Amount *
                this.getRegularPaymentsCount(
                    JsonDateParser.toDate(
                        model.ThirdPartyRegularPayment.NextPaymentDate ??
                            model.ThirdPartyRegularPayment?.FirstCollectionDate
                    ),
                    model.ThirdPartyRegularPayment.Frequency,
                    endDate
                );
        }

        return total;
    }

    static getRegularPaymentsCount(startDate: Date, frequent: Frequency, endDate: Date): number {
        let count = 0;
        let gapMonth = 1;
        switch (frequent) {
            case Frequency.Monthly:
                gapMonth = 1;
                break;
            case Frequency.Quarterly:
                gapMonth = 3;
                break;
            case Frequency.HalfYearly:
                gapMonth = 6;
                break;
            case Frequency.Yearly:
                gapMonth = 12;
                break;
        }
        while (endDate >= startDate) {
            count++;
            endDate = addMonths(endDate, -gapMonth);
        }
        return count;
    }
}
